import _ from "lodash";

export const buildTimerStylesheet = (builder, device, cta, element) => {
    let options = { ...element.options };

    let padding;
    if (options["timer-padding"]) {
      const paddingValue = parseInt(options["timer-padding"]);
      padding = `${paddingValue / 2}px ${paddingValue}px`;
    }

    let paddingMobile;
    if (options["timer-padding-mobile"]) {
      const paddingValueMobile = parseInt(options["timer-padding-mobile"]);
      paddingMobile = `${paddingValueMobile / 2}px ${paddingValueMobile}px`;
    }

    let borderRadius = "";
    if (options["timer-radius"] == "cf-not-rounded") {
      borderRadius = "0px";
    }
    if (options["timer-radius"] == "cf-slightly-rounded") {
      borderRadius = "4px";
    }
    if (options["timer-radius"] == "cf-fully-rounded") {
      borderRadius = "100px";
    }
    if (options["timer-radius"] == "custom") {
      borderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          borderRadius += `${
            _.isNil(options["timer-radius-" + side]) == false
              ? options["timer-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let boxShadow;

    if (options["timer-shadow"] == "None") {
      boxShadow = "none";
    }

    if (options["timer-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["timer-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["timer-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["timer-shadow-horizontal-distance"]
          ? `${element.options["timer-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["timer-shadow-vertical-distance"]
          ? `${element.options["timer-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["timer-shadow-blur-radius"]
          ? `${element.options["timer-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["timer-shadow-spread-radius"]
          ? `${element.options["timer-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["timer-shadow-color"]
          ? element.options["timer-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    // prettier-ignore
    const desktopStyles = 
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-card .cf-timer-unit-number {
  ${padding ? 'padding: ' + padding + ' !important;' : ''}
  ${options["timer-number-size"] ? 'font-size: ' + options["timer-number-size"] + 'px !important;' : ''}
  ${options["timer-number-font"] ? 'font-family: ' + options["timer-number-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-number-font-weight'] ? 'font-weight: ' + options['timer-number-font-weight'] + ' !important;' : ''}
  ${options["timer-background-color"] ? 'background: ' + options["timer-background-color"] + ' !important;' : ''}
  ${options["timer-number-color"] ? 'color: ' + options["timer-number-color"] + ' !important;' : ''}
  ${options["timer-border-style"] ? 'border-style: ' + options["timer-border-style"] + '!important;' : ''}
  ${_.isNil(options["timer-border-width"]) == false ? 'border-width: ' + options["timer-border-width"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-left"]) == false ? 'border-left-width: ' + options["timer-border-width-left"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-right"]) == false ? 'border-right-width: ' + options["timer-border-width-right"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["timer-border-width-bottom"] + 'px !important;' : ''}
  ${_.isNil(options["timer-border-width-top"]) == false ? 'border-top-width: ' + options["timer-border-width-top"] + 'px !important;' : ''}
  ${options["timer-border-color"] ? 'border-color: ' + options["timer-border-color"] + ' !important;' : ''}
  ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-card .cf-timer-unit-text {
  ${options["timer-unit-size"] ? 'font-size: ' + options["timer-unit-size"] + 'px !important;' : ''}
  ${options["timer-unit-font"] ? 'font-family: ' + options["timer-unit-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-unit-font-weight'] ? 'font-weight: ' + options['timer-unit-font-weight'] + ' !important;' : ''}
  ${options["timer-unit-color"] ? 'color: ' + options["timer-unit-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-inline .cf-timer-unit-number {
  ${options["timer-number-size"] ? 'font-size: ' + options["timer-number-size"] + 'px !important;' : ''}
  ${options["timer-number-font"] ? 'font-family: ' + options["timer-number-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-number-font-weight'] ? 'font-weight: ' + options['timer-number-font-weight'] + ' !important;' : ''}
  ${options["timer-number-color"] ? 'color: ' + options["timer-number-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-inline .cf-timer-unit-text {
  ${options["timer-unit-size"] ? 'font-size: ' + options["timer-unit-size"] + 'px !important;' : ''}
  ${options["timer-unit-font"] ? 'font-family: ' + options["timer-unit-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-unit-font-weight'] ? 'font-weight: ' + options['timer-unit-font-weight'] + ' !important;' : ''}
  ${options["timer-unit-color"] ? 'color: ' + options["timer-unit-color"] + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message h1, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message h2, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message h3, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message h4, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message h5, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message p, 
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message span {
  ${options["timer-message-size"] ? 'font-size: ' + options["timer-message-size"] + 'px !important;' : ''}
  ${options["timer-message-font"] ? 'font-family: ' + options["timer-message-font"] + ', Helvetica, Arial, sans-serif !important;' : ''}
  ${options['timer-message-font-weight'] ? 'font-weight: ' + options['timer-message-font-weight'] + ' !important;' : ''}
  ${options["timer-message-color"] ? 'color: ' + options["timer-message-color"] + ' !important;' : ''}
}`;

    // prettier-ignore
    const mobileStyles = 
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-card .cf-timer-unit-number, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-inline .cf-timer-unit-number {
  ${options["timer-number-size-mobile"] ? 'font-size: ' + options["timer-number-size-mobile"] + 'px !important;' : ''}
  ${paddingMobile ? 'padding: ' + paddingMobile + ' !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-card .cf-timer-unit-text, #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-inline .cf-timer-unit-text {
  ${options["timer-unit-size-mobile"] ? 'font-size: ' + options["timer-unit-size-mobile"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-timer-message {
  ${options["timer-message-size-mobile"] ? 'font-size: ' + options["timer-message-size-mobile"] + 'px !important;' : ''}
}`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
